module.exports = __webpack_public_path__ + "img/备料打印.1a7b20c5.svg";